var OleFileUtil = {};
var BufferUtil = {
  // help functions to read data from array
  validate: function validate(array, offset) {
    if (!array || offset >= array.length || offset < 0) {
      throw new Error('empty array or offset is out of range');
    }
  },
  readUInt32LE: function readUInt32LE(array, offset) {
    BufferUtil.validate(array, offset);
    BufferUtil.validate(array, offset + 3);
    return (array[offset] | array[offset + 1] << 8 | array[offset + 2] << 16) + array[offset + 3] * 0x1000000;
  },
  readInt8LE: function readInt8LE(array, offset) {
    BufferUtil.validate(array, offset);
    return array[offset];
  },
  readInt16LE: function readInt16LE(array, offset) {
    BufferUtil.validate(array, offset);
    BufferUtil.validate(array, offset + 1);
    var u = array[offset + 1] * (1 << 8) + array[offset];
    return u < 0x8000 ? u : (0xffff - u + 1) * -1;
  },
  readInt32LE: function readInt32LE(array, offset) {
    BufferUtil.validate(array, offset);
    BufferUtil.validate(array, offset + 3);
    return (array[offset + 3] << 24) + (array[offset + 2] << 16) + (array[offset + 1] << 8) + array[offset];
  },
  readWChar: function readWChar(array, offset) {
    BufferUtil.validate(array, offset);
    return String.fromCharCode(array[offset]);
  },
  convertToString: function convertToString(array) {
    var stringOutput = '';
    for (var i = 0; i < array.length; i += 2) {
      if (array[i] === 0) {
        break;
      }
      stringOutput += BufferUtil.readWChar(array, i);
    }
    return stringOutput;
  }
};
var RvtInfoReader = {
  ErrMsg: {
    success: 'success',
    invalidFileSize: 'invalidFileSize',
    notRvt: 'notRvt',
    corruptFile: 'corruptFile',
    unknownRvtVersion: 'unknownRvtVersion',
    unsupportedRvtVersion: 'unsupportedRvtVersion',
    readFileError: 'readFileError',
    unsupportedBrowser: 'unsupportedBrowser'
  },
  create: function create() {
    var Setting = {
      minSupportedVersion: 2014,
      maxSupportedVersion: 2026
    };
    var reader = {};
    reader.getMinSupportVersion = function () {
      return Setting.minSupportedVersion;
    };
    reader.setMinSupportVersion = function (val) {
      if (typeof val !== 'number') {
        return;
      }
      if (val <= 0) {
        throw new Error('Argument error');
      }
      if (val > Setting.maxSupportedVersion) {
        throw new Error('Min value is greater than max value');
      }
      Setting.minSupportedVersion = val;
    };
    reader.getMaxSupportVersion = function () {
      return Setting.maxSupportedVersion;
    };
    reader.setMaxSupportVersion = function (val) {
      if (typeof val !== 'number') {
        return;
      }
      if (val <= 0) {
        throw new Error('Argument error');
      }
      if (val < Setting.minSupportedVersion) {
        throw new Error('Max value is less than min value');
      }
      Setting.maxSupportedVersion = val;
    };

    // API to get Revit file info, pass a function(info) {} as the callback
    // info has members of FileName, IsSupported, RvtVersion and ErrorMessage.
    reader.getRvtInfo = function (file, cb) {
      if (!(file instanceof File)) {
        throw new Error('An instance of File is needed.');
      }
      cb = cb || function (fileInfo) {};
      var fileName = file.name;
      var info = {
        FileName: fileName,
        IsSupported: false,
        RvtVersion: -1,
        ErrorMessage: ''
      };
      if (file.size === 0) {
        info.ErrorMessage = RvtInfoReader.ErrMsg.invalidFileSize;
        cb(info);
        return;
      }
      var ext = fileName.substring(fileName.length - 4, fileName.length).toLowerCase();
      // check extension, we support rvt for now
      if (ext !== '.rvt') {
        info.ErrorMessage = RvtInfoReader.ErrMsg.notRvt;
        cb(info);
        return;
      }

      // parsing header
      var header = {};
      OleFileUtil.readRvtFile(file, 0, 512).then(function (headBuffer) {
        if (headBuffer) {
          header = OleFileUtil.parseHeader(headBuffer);
          header._file = file;
          OleFileUtil.readMSAT(header).then(function () {
            return OleFileUtil.readSAT(header);
          }).then(function () {
            return OleFileUtil.readSSAT(header);
          }).then(function () {
            return OleFileUtil.readDirectoryTree(header);
          }).then(function () {
            return OleFileUtil.readStream(header, 'BasicFileInfo');
          }).then(function (data) {
            var rvtVersion = OleFileUtil.parseBasicFileInfoStream(data);
            info.RvtVersion = rvtVersion;
            if (info.RvtVersion >= reader.getMinSupportVersion() && info.RvtVersion <= reader.getMaxSupportVersion()) {
              info.IsSupported = true;
            } else {
              info.IsSupported = false;
              info.ErrorMessage = RvtInfoReader.ErrMsg.unsupportedRvtVersion;
            }
            cb(info);
          })["catch"](function (ex) {
            info.ErrorMessage = ex.message;
            cb(info);
          });
        }
      })["catch"](function (ex) {
        info.ErrorMessage = ex.message;
        cb(info);
      });
    };
    return reader;
  }
};

/*
    Copyright (c) 2012 Chris Geiersbach
    Permission is hereby granted, free of charge, to any person obtaining a copy
    of this software and associated documentation files (the "Software"), to deal
    in the Software without restriction, including without limitation the rights
    to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
    copies of the Software, and to permit persons to whom the Software is
    furnished to do so, subject to the following conditions:
    The above copyright notice and this permission notice shall be included in
    all copies or substantial portions of the Software.
    THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
    IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
    FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
    AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
    LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
    OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
    THE SOFTWARE.
    */
OleFileUtil = {
  readRvtFile: function readRvtFile(file, fileOffset, length) {
    return new Promise(function (resolve, reject) {
      var fileReader = new FileReader();
      fileReader.onloadend = function (e) {
        var _fileReader = e.target;
        var headBuffer = new Uint8Array(_fileReader.result);
        resolve(headBuffer);
      };
      fileReader.onerror = function (e) {
        reject(new Error(RvtInfoReader.ErrMsg.readFileError));
      };
      fileReader.onabort = function (e) {
        reject(new Error(RvtInfoReader.ErrMsg.readFileError));
      };
      var fileSeg;
      if (file.webkitSlice) {
        fileSeg = file.webkitSlice(fileOffset, fileOffset + length);
      } else if (file.mozSlice) {
        fileSeg = file.mozSlice(fileOffset, fileOffset + length);
      } else if (file.slice) {
        fileSeg = file.slice(fileOffset, fileOffset + length);
      }
      if (!fileSeg) {
        reject(new Error(RvtInfoReader.ErrMsg.unsupportedBrowser));
        return;
      }
      fileReader.readAsArrayBuffer(fileSeg);
    });
  },
  parseHeader: function parseHeader(headerBuffer) {
    var constStr = 'D0CF11E0A1B11AE1';
    var first8Bytes = '';
    for (var i = 0; i < 8; ++i) {
      first8Bytes += headerBuffer[i].toString(16).toUpperCase();
    }
    if (first8Bytes !== constStr) {
      throw new Error(RvtInfoReader.ErrMsg.notRvt);
    }
    var header = {};
    header.secSize = 1 << BufferUtil.readInt16LE(headerBuffer, 30); // Size of a sector
    header.shortSecSize = 1 << BufferUtil.readInt16LE(headerBuffer, 32); // Size of a short sector in the short-stream container stream
    header.SATSize = BufferUtil.readInt32LE(headerBuffer, 44); // Number of sectors used for the Sector Allocation Table
    header.dirSecId = BufferUtil.readInt32LE(headerBuffer, 48); // SecID of first sector of the directory stream
    header.minSizeStandStream = BufferUtil.readInt32LE(headerBuffer, 56); // Minimum size of a standard stream, streams size smaller than this value are stored as short-streams
    header.SSATSecId = BufferUtil.readInt32LE(headerBuffer, 60); // SecID of first sector of the short-sector allocation table, or -2 if no additional sectors used
    header.SSATSize = BufferUtil.readInt32LE(headerBuffer, 64); // Total number of sectors used for the short-sector allocation table
    header.MSATSecId = BufferUtil.readInt32LE(headerBuffer, 68); // SecID of first sector of the master sector allocation table
    header.MSATSize = BufferUtil.readInt32LE(headerBuffer, 72); // Total number of sectors used for the master sector allocation table

    header.partialMSAT = new Array(109);
    // The first 109 sectors of the MSAT
    for (var _i = 0; _i < 109; _i++) header.partialMSAT[_i] = BufferUtil.readInt32LE(headerBuffer, 76 + _i * 4);
    return header;
  },
  parseBasicFileInfoStream: function parseBasicFileInfoStream(data) {
    // basic file info format
    // 4 bytes: version
    var offset = 0;
    var version = BufferUtil.readInt32LE(data, offset);

    // char: is workshared
    offset += 4;
    // const isworkshared = BufferUtil.readInt8LE(data, offset);

    // char: workshared status
    offset += 1;
    // const worksharedStatus = BufferUtil.readInt8LE(data, offset);

    // username string: length (int) + content (TChar * length)
    offset += 1;
    var userNameLen = BufferUtil.readInt32LE(data, offset);

    // skip 4 + userNameLen * 2
    offset += 4 + userNameLen * 2;

    // central path string: length (int) + content (TChar * length)
    var centralPathLen = BufferUtil.readUInt32LE(data, offset);

    // skip 4 +  centralPathLen * 2
    offset += 4 + centralPathLen * 2;
    var format = '-1';
    var rvtVersion = -1;
    if (version < 12) {
      // build version: length (int) + content (TChar * length)
      var buildVersionLen = BufferUtil.readUInt32LE(data, offset);
      offset += 4;
      var buildVersionArray = data.slice(offset, offset + buildVersionLen * 2);
      var buildVersion = BufferUtil.convertToString(buildVersionArray);
      var nFindLeft = buildVersion.indexOf('(');
      if (nFindLeft < 0) {
        return rvtVersion;
      }
      var productReleaseName = buildVersion.slice(0, nFindLeft - 1);
      var posYear = productReleaseName.indexOf('20');
      if (posYear < 0) {
        return 2009;
      }
      format = productReleaseName.substring(posYear);
      rvtVersion = parseInt(format);
    } else {
      // format string: length (int) + content (TChar * length)
      var formatLen = BufferUtil.readUInt32LE(data, offset);
      offset += 4;
      var formatArray = data.slice(offset, offset + formatLen * 2);
      format = BufferUtil.convertToString(formatArray);
      rvtVersion = parseInt(format);
    }
    return rvtVersion;
  },
  readSector: function readSector(file, secId, secSize) {
    return OleFileUtil.readSectors(file, [secId], secSize);
  },
  getFileOffsetForSec: function getFileOffsetForSec(secId, secSize) {
    return (secId + 1) * secSize;
  },
  getFileOffsetForShortSec: function getFileOffsetForShortSec(shortStreamSecIds, shortSecId, secSize, shortSecSize) {
    var shortStreamOffset = shortSecId * shortSecSize;
    var secIdIndex = Math.floor(shortStreamOffset / secSize);
    var secOffset = shortStreamOffset % secSize;
    var secId = shortStreamSecIds[secIdIndex];
    return OleFileUtil.getFileOffsetForSec(secId, secSize) + secOffset;
  },
  readSectors: function readSectors(file, secIds, secSize) {
    return new Promise(function (resolve, reject) {
      var buffer = new Uint8Array(secIds.length * secSize);
      var i = 0;
      var _loopCallback = function loopCallback() {
        var bufferOffset = i * secSize;
        var fileOffset = OleFileUtil.getFileOffsetForSec(secIds[i], secSize);
        OleFileUtil.readRvtFile(file, fileOffset, secSize).then(function (content) {
          buffer.set(content, bufferOffset);
          i++;
          if (i < secIds.length) {
            _loopCallback();
          } else {
            resolve(buffer);
          }
        })["catch"](function (error) {
          reject(error);
        });
      };
      _loopCallback();
    });
  },
  readShortSector: function readShortSector(file, shortStreamSecIds, secId, secSize, shortSecSize) {
    return OleFileUtil.readShortSectors(file, shortStreamSecIds, [secId], secSize, shortSecSize);
  },
  readShortSectors: function readShortSectors(file, shortStreamSecIds, secIds, secSize, shortSecSize) {
    return new Promise(function (resolve, reject) {
      var buffer = new Uint8Array(secIds.length * shortSecSize);
      var i = 0;
      var _loopCallback2 = function loopCallback() {
        var fileOffset = OleFileUtil.getFileOffsetForShortSec(shortStreamSecIds, secIds[i], secSize, shortSecSize);
        var bufferOffset = i * shortSecSize;
        OleFileUtil.readRvtFile(file, fileOffset, shortSecSize).then(function (content) {
          buffer.set(content, bufferOffset);
          i++;
          if (i < secIds.length) {
            _loopCallback2();
          } else {
            resolve(buffer);
          }
        })["catch"](function (error) {
          reject(error);
        });
      };
      _loopCallback2();
    });
  },
  readMSAT: function readMSAT(header) {
    return new Promise(function (resolve, reject) {
      if (!header) {
        reject(new Error('parsing header error'));
        return;
      }
      header._MSAT = header.partialMSAT.slice(0);
      header._MSAT.length = header.SATSize;
      if (header.SATSize <= 109 || header.MSATSize === 0) {
        resolve();
        return;
      }
      var secId = header.MSATSecId;
      var i = 0;
      var currMSATIndex = 109;
      var _loopCallback3 = function loopCallback() {
        OleFileUtil.readSector(header._file, secId, header.secSize).then(function (sectorBuffer) {
          for (var s = 0; s < header.secSize - 4; s += 4) {
            if (currMSATIndex >= header.SATSize) break;else header._MSAT[currMSATIndex] = BufferUtil.readInt32LE(sectorBuffer, s);
            currMSATIndex++;
          }
          secId = BufferUtil.readInt32LE(sectorBuffer, header.secSize - 4);
          i++;
          if (i < header.MSATSize) {
            _loopCallback3();
          } else {
            resolve();
          }
        })["catch"](function (error) {
          reject(error);
        });
      };
      _loopCallback3();
    });
  },
  readSAT: function readSAT(header) {
    return new Promise(function (resolve, reject) {
      if (!header) {
        reject(new Error('header not exist'));
      }
      OleFileUtil.readSectors(header._file, header._MSAT, header.secSize).then(function (buffer) {
        header._SAT = new Array(buffer.length / 4);
        for (var i = 0; i < buffer.length / 4; i++) {
          header._SAT[i] = BufferUtil.readInt32LE(buffer, i * 4);
        }
        resolve();
      })["catch"](function (error) {
        reject(error);
      });
    });
  },
  readSSAT: function readSSAT(header) {
    return new Promise(function (resolve, reject) {
      var secIds = [];
      try {
        secIds = OleFileUtil.getSecIdChain(header._SAT, header.SSATSecId);
      } catch (e) {
        reject(e);
        return;
      }
      OleFileUtil.readSectors(header._file, secIds, header.secSize).then(function (buffer) {
        header._SSAT = new Array(buffer.length / 4);
        for (var i = 0; i < buffer.length / 4; i++) {
          header._SSAT[i] = BufferUtil.readInt32LE(buffer, i * 4);
        }
        resolve();
      })["catch"](function (error) {
        reject(error);
      });
    });
  },
  getSecIdChain: function getSecIdChain(allocationTable, startSecId) {
    var secId = startSecId;
    var secIds = [];
    while (secId !== -2 && secId >= 0 && secId < allocationTable.length) {
      if (secIds.length >= allocationTable.length) throw new Error(RvtInfoReader.ErrMsg.corruptFile);
      secIds.push(secId);
      secId = allocationTable[secId];
    }
    return secIds;
  },
  readDirectoryTree: function readDirectoryTree(header) {
    return new Promise(function (resolve, reject) {
      var secIds = [];
      try {
        secIds = OleFileUtil.getSecIdChain(header._SAT, header.dirSecId);
      } catch (e) {
        reject(e);
        return;
      }
      OleFileUtil.readSectors(header._file, secIds, header.secSize).then(function (buffer) {
        var count = buffer.length / 128;
        header._DirTreeEntries = new Array(count);
        var rootEntry;
        for (var i = 0; i < count; i++) {
          var offset = i * 128;
          var nameLength = Math.max(BufferUtil.readInt16LE(buffer, 64 + offset) - 1, 0);
          var entry = {};
          var nameArray = buffer.slice(offset, nameLength + offset);
          entry.name = BufferUtil.convertToString(nameArray);
          entry.type = BufferUtil.readInt8LE(buffer, 66 + offset);
          entry.nodeColor = BufferUtil.readInt8LE(buffer, 67 + offset);
          entry.left = BufferUtil.readInt32LE(buffer, 68 + offset);
          entry.right = BufferUtil.readInt32LE(buffer, 72 + offset);
          entry.storageDirId = BufferUtil.readInt32LE(buffer, 76 + offset);
          entry.secId = BufferUtil.readInt32LE(buffer, 116 + offset);
          entry.size = BufferUtil.readInt32LE(buffer, 120 + offset);
          header._DirTreeEntries[i] = entry;
          if (entry.type === 5) rootEntry = entry;
        }
        try {
          header._shortStreamSecIds = OleFileUtil.getSecIdChain(header._SAT, rootEntry.secId);
        } catch (e) {
          reject(e);
          return;
        }
        resolve();
      })["catch"](function (error) {
        reject(error);
      });
    });
  },
  readStream: function readStream(header, streamName) {
    return new Promise(function (resolve, reject) {
      var entry;
      for (var i = 0; i < header._DirTreeEntries.length; ++i) {
        entry = header._DirTreeEntries[i];
        if (entry.name === streamName) break;
      }
      if (!entry) {
        resolve(null);
        return;
      }
      var bytes = entry.size;
      var allocationTable = header._SAT;
      var shortStream = false;
      if (bytes < header.minSizeStandStream) {
        shortStream = true;
        allocationTable = header._SSAT;
      }
      var secIds = [];
      try {
        secIds = OleFileUtil.getSecIdChain(allocationTable, entry.secId);
      } catch (e) {
        reject(e);
        return;
      }
      if (shortStream) {
        OleFileUtil.readShortSectors(header._file, header._shortStreamSecIds, secIds, header.secSize, header.shortSecSize).then(function (buffer) {
          resolve(buffer);
        })["catch"](function (error) {
          reject(error);
        });
      } else {
        OleFileUtil.readSectors(header._file, secIds, header.secSize).then(function (buffer) {
          resolve(buffer);
        })["catch"](function (error) {
          reject(error);
        });
      }
    });
  }
};
var revitReader = RvtInfoReader.create();
export default revitReader;